import { render, staticRenderFns } from "./CadastroFuncionarioPreContratracaoDocumentos.vue?vue&type=template&id=522a11b0&scoped=true"
import script from "./CadastroFuncionarioPreContratracaoDocumentos.vue?vue&type=script&lang=js"
export * from "./CadastroFuncionarioPreContratracaoDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a11b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VTextField})
